import { render, staticRenderFns } from "./DineInCoreSidebar.vue?vue&type=template&id=2b2eddc2"
import script from "./DineInCoreSidebar.vue?vue&type=script&lang=js"
export * from "./DineInCoreSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports